import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit, AfterViewInit {
    @ViewChild('heroTitle') heroTitle!: ElementRef;
    @ViewChild('storyFigure') storyFigure!: ElementRef;
    @ViewChild('storyImg') storyImg!: ElementRef;

    // Fixed: restablished the data properties bound to your *ngFor structural templates
    aboutContent = [
        {
            title: "Our Culinary Journey & Dream",
            paragraph: "Kitchen Magic began as a dream to share authentic flavors with the world, not just through food delivery, but through real human connection. That vision led to the creation of a mobile food truck experience and cloud kitchen—a place where food, stories, culture, and people come together in absolute harmony.",
            chefName: "Nagarajan Murugan",
            chefRole: "Founder & Chef – Kitchen Magic",
            chefDescription: "Kitchen Magic began as a dream to share authentic flavors with the world, not just through food delivery, but through real human connection. That vision led to the creation of a food truck and cloud kitchen — a place where food, stories, culture, and people come together.",
            content: [
                {
                    title: "Our Goal",
                    paragraph: "To consistently innovate contemporary street food and traditional delicacies while delivering unmatched high-quality food safety directly to your neighborhoods."
                },
                {
                    title: "Our Mission",
                    paragraph: "To design a sustainable framework combining cloud kitchen speeds with personal street-side truck operations to build food connections everywhere."
                },
                {
                    title: "Our Vision",
                    paragraph: "To scale up authentic flavors using clean, nature-friendly practices, turning street food vendor models into high-end casual community experiences."
                }
            ]
        }
    ];

    constructor(private meta: Meta, private titleService: Title) { }

    ngOnInit(): void {
        this.titleService.setTitle('Our Story | Kitchen Magic');
        this.meta.updateTag({
            name: 'description',
            content: 'The journey of Kitchen Magic - Born from family traditions, village style cooking, and authentic South Indian roots.'
        });
    }

    // Assigns dynamic micro-icons cleanly to your core content items loop matrix
    getIconForTitle(title: string): string {
        switch (title?.toLowerCase().trim()) {
            case 'our goal':
                return 'bx-target-lock';
            case 'our mission':
                return 'bx-compass';
            case 'our vision':
                return 'bx-bulb';
            default:
                return 'bx-check-shield';
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                    } else {
                        // remove so the animation replays next time it scrolls into view
                        entry.target.classList.remove('active');
                    }
                });
            }, { threshold: 0.2 });
            document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
        }, 200);
    }

    @HostListener('window:scroll', ['$event'])
    handleScroll() {
        const scrollY = window.scrollY;

        if (this.heroTitle) {
            this.heroTitle.nativeElement.style.transform = `translateY(${scrollY * 0.25}px)`;
        }

        // Scroll-based parallax on the Our Story image
        if (this.storyFigure && this.storyImg) {
            const rect = this.storyFigure.nativeElement.getBoundingClientRect();
            const viewH = window.innerHeight;
            // -1 (figure below viewport) -> 1 (figure above viewport)
            const progress = (viewH / 2 - (rect.top + rect.height / 2)) / (viewH / 2 + rect.height / 2);
            const move = progress * 38; // px of vertical drift
            this.storyImg.nativeElement.style.transform = `scale(1.18) translateY(${move}px)`;
        }
    }
}